// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"AddTransaction_backdrop__1inBj","modal":"AddTransaction_modal__1N5jD"};